import { BiColorStyle, BiColorStyleProps, BuildUpToolStyle, FvgToolStyle, MonoColorStyle, PDToolStyle, PoiStyleType, TextStyleProps, ToolStyle } from "../config/smpa";
import { hub } from "../hub";
import { getColor, isTransparent } from "../tv";

export class styleSet {
	bullColor: string = null;
	bearColor: string = null;
	bullTextColor: string = null;
	bearTextColor: string = null;
	_on = true;

	private d: ToolStyle = null;

	get on() {
		return this.d.on && this._on;
	}
	get style() {
		return this.d;
	}
	update(bi: ToolStyle) {
		this.d = bi;
	}
	updateBi(bi: BiColorStyle) {
		this.d = bi;
		const txtOpacity = bi.txtOp / 100.0;
		this.bullColor = getColor(bi.buCol);
		this.bearColor = getColor(bi.beCol);
		this.bullTextColor = getColor(bi.buCol, txtOpacity);
		this.bearTextColor = getColor(bi.beCol, txtOpacity);
	}
	updateBiProps(st: BiColorStyleProps | TextStyleProps) {
		const txtOpacity = (st as TextStyleProps).txtOp / 100.0;
		const bi = st as BiColorStyleProps;
		this.bullColor = getColor(bi.buCol);
		this.bearColor = getColor(bi.beCol);
		this.bullTextColor = getColor(bi.buCol, txtOpacity);
		this.bearTextColor = getColor(bi.beCol, txtOpacity);
	}
	updateMono(bi: MonoColorStyle) {
		this.d = bi;
		const txtOpacity = bi.txtOp / 100.0;
		this.bullColor = getColor(bi.col);
		this.bearColor = this.bullColor;
		this.bullTextColor = getColor(bi.col, txtOpacity);
		this.bearTextColor = this.bullTextColor;
	}
	get(isbull: boolean) {
		if (isbull)
			return this.bullColor;
		return this.bearColor;
	}
	getText(isbull: boolean) {
		if (isbull)
			return this.bullTextColor;
		return this.bearTextColor;
	}
}
export class markToolsStyles {
	targets: styleSet;

	sbpoi: styleSet;
	mbpoi: styleSet;
	bbpoi: styleSet;
	obpoi: styleSet;


	open: styleSet;
	sweep: styleSet;
	raid: styleSet;
	eq_s: styleSet;
	eq_us: styleSet;
	eq_e: styleSet;
	ca_s: styleSet;
	ca_us: styleSet;
	ca_e: styleSet;
	level: styleSet;
	fvg_u: styleSet;
	fvg_upf: styleSet;
	fvg_f: styleSet;
	fvg_ff: styleSet;
	sessionsOn: boolean;
	asesColor: string;
	fsesColor: string;
	lsesColor: string;
	nsesColor: string;
	pd: styleSet;
	alerts: styleSet;

	updateView() {
		const disp = hub.smcConfig;
		this.targets = getFromBi(disp.targets, this.targets);
		//disp.poi.lb.on = disp.poi.on;
		//disp.poi.mr.on = disp.poi.on;
		//disp.poi.ol.on = disp.poi.on;
		//if (disp.poi.by == PoiStyleType.HistoryPos) {
		//	this.sbpoi = getFromBi(disp.poi.lb, this.sbpoi);
		//	this.mbpoi = getFromBi(disp.poi.mr, this.mbpoi);
		//	this.bbpoi = getFromBi(disp.poi.ol, this.bbpoi);
		//} else {
		this.alerts = getFromMono(disp.alerts, this.alerts);
		this.sbpoi = getFromBi(disp.poi.sb, this.sbpoi);
		this.bbpoi = getFromBi(disp.poi.bb, this.bbpoi);
		this.mbpoi = getFromBi(disp.poi.mb, this.mbpoi);
		this.obpoi = getFromBi(disp.poi.ob, this.obpoi);
		//}
		this.open = getFromMono(disp.open, this.open);
		this.sweep = getFromBi(disp.sweep, this.sweep);
		this.raid = getFromBi(disp.raid, this.raid);

		this.eq_s = getBuildUps(disp.eqLiq, true, this.eq_s);
		this.eq_us = getBuildUps(disp.eqLiq, false, this.eq_us);
		this.eq_e = getBuildUps(disp.eqLiq, null, this.eq_e);
		this.ca_s = getBuildUps(disp.caLiq, true, this.ca_s)
		this.ca_us = getBuildUps(disp.caLiq, false, this.ca_us);
		this.ca_e = getBuildUps(disp.caLiq, null, this.ca_e);

		this.level = getFromBi(disp.level, this.level);
		this.fvg_u = getFromBi(disp.fvg, this.fvg_u);
		if (disp.fvg.upf)
			this.fvg_upf = getFvg(disp.fvg, disp.fvg.beUPFCol, disp.fvg.buUPFCol, this.fvg_upf == this.fvg_u ? null : this.fvg_upf);
		else
			this.fvg_upf = this.fvg_u;
		this.fvg_f = getFvg(disp.fvg, disp.fvg.beFCol, disp.fvg.buFCol, this.fvg_f);
		if (disp.fvg.ff)
			this.fvg_ff = getFvg(disp.fvg, disp.fvg.beFFCol, disp.fvg.buFFCol, this.fvg_ff == this.fvg_f ? null : this.fvg_ff);
		else
			this.fvg_ff = this.fvg_f;
		this.sessionsOn = disp.sessions.on;
		this.asesColor = getColor(disp.sessions.aCol);
		this.fsesColor = getColor(disp.sessions.ffCol);
		this.lsesColor = getColor(disp.sessions.loCol);
		this.nsesColor = getColor(disp.sessions.nyCol);
		this.pd = getFromPrem(disp.pd, this.pd);

		function getFromMono(bi: MonoColorStyle, cset: styleSet) {
			cset ??= new styleSet();
			cset.updateMono(bi);
			return cset;
		}

		function getFvg(bi: FvgToolStyle, be: string, bu: string, cset: styleSet) {
			cset ??= new styleSet();
			cset.update(bi);
			cset._on = (!isTransparent(be) || !isTransparent(bu));
			cset.bullColor = getColor(bu);
			cset.bearColor = getColor(be);
			const txtOpacity = bi.txtOp / 100.0;
			cset.bullTextColor = getColor(bu, txtOpacity);
			cset.bearTextColor = getColor(be, txtOpacity);
			return cset;
		}
		function getFromPrem(bi: PDToolStyle, cset: styleSet) {
			cset ??= new styleSet();
			cset.update(bi)
			cset.bullColor = getColor(bi.discCol);
			cset.bearColor = getColor(bi.premCol);
			cset.bullTextColor = getColor(bi.discCol, 1);
			cset.bearTextColor = getColor(bi.premCol, 1);
			return cset;
		}
		function getFromBi(bi: BiColorStyle, cset: styleSet) {
			cset ??= new styleSet();
			cset.updateBi(bi);
			return cset;
		}

		function getBuildUps(bi: BuildUpToolStyle, s: boolean, cset: styleSet) {
			cset ??= new styleSet();
			if (s == null)
				cset.updateBi(bi.extd);
			else if (s)
				cset.updateBi(bi.swept);
			else
				cset.updateBi(bi.unswept);
			return cset;
		}
	}
}
